module.exports = __webpack_public_path__ + "assets/advantages-time-6aa414.svg";